module.exports = __webpack_public_path__ + "img/user-plus.55aa0399.svg";